import React from "react";
import Header from "./Header";
import ReactParticles from "./ReactParticles.js";


const Home = () => {
  return (
    <React.Fragment>      
      <ReactParticles />
      <Header />
    </React.Fragment>
  );
};

export default Home;